import React, {Component} from 'react';
import {Col, Grid, Row} from "react-bootstrap";
import TopBreadcumb from "../../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SidebarComponent from "../../../../shared/sidebar/SidebarComponent";
import SubHeader from "../../../../shared/sidebar/SubHeader";
import Links from "../../../../utilities/linksConfig/Links";
import '../../../../styles/KalendarzTable.css'
import $ from 'jquery';
import moment from 'moment'
import fc from 'fullcalendar'
import scheduler from 'fullcalendar-scheduler'
import '../../../../../node_modules/fullcalendar/dist/fullcalendar.css'
import '../../../../../node_modules/fullcalendar-scheduler/dist/scheduler.css'
import KalendarzService from "./KalendarzService";
import {Redirect} from "react-router-dom";
import {TopAlertInformacja} from "../../../../componentsTopsa/alerty/TopAlerts";
import TopIf from "../../../../componentsTopsa/if/TopIf";
import KonfiguracjaHeader from "../../../../shared/headers/KonfiguracjaHeader";
import LogowanieService from "../../../logowanie/LogowanieService";

export default class KalendarzContainer extends Component {

    constructor(props) {
        super(props);

        localStorage.removeItem('EBUS_EdycjaWynajem')

        let startDate = moment().startOf('day').format().substr(0,16)
        let view = 'timelineTenDays'

        if (localStorage.getItem('kalendarz') !== null && localStorage.getItem('kalendarz') !== undefined) {
            startDate = JSON.parse(localStorage.getItem('kalendarz')).startDate
            view = JSON.parse(localStorage.getItem('kalendarz')).view
            localStorage.removeItem('kalendarz')
        }

        this.state = {
            events: [],
            loading: true,
            pokazFormularz: false,
            startDate: startDate,
            view: view
        }
    }

    componentDidMount() {

        $('body').on('click', 'button.fc-prev-button', () =>
            this.getEventsNow(moment($('#calendarWynajem').fullCalendar('getDate')).format().substr(0,16), moment($('#calendarWynajem').fullCalendar('getDate')).add($('#calendarWynajem').fullCalendar('getView').slotCnt, 'days').endOf('day').format().substr(0,16), $('#calendarWynajem').fullCalendar('getView').name)
        );

        $('body').on('click', 'button.fc-next-button', () =>
            this.getEventsNow(moment($('#calendarWynajem').fullCalendar('getDate')).format().substr(0,16), moment($('#calendarWynajem').fullCalendar('getDate')).add($('#calendarWynajem').fullCalendar('getView').slotCnt, 'days').endOf('day').format().substr(0,16), $('#calendarWynajem').fullCalendar('getView').name)
        );

        $('body').on('click', 'button.fc-timelineEightDays-button', () =>
            this.getEventsNow(moment($('#calendarWynajem').fullCalendar('getDate')).startOf('week').format().substr(0,16), moment($('#calendarWynajem').fullCalendar('getDate')).add($('#calendarWynajem').fullCalendar('getView').slotCnt, 'days').endOf('day').format().substr(0,16), $('#calendarWynajem').fullCalendar('getView').name)
        );

        $('body').on('click', 'button.fc-timelineTenDays-button', () =>
            this.getEventsNow(moment($('#calendarWynajem').fullCalendar('getDate')).format().substr(0,16), moment($('#calendarWynajem').fullCalendar('getDate')).add($('#calendarWynajem').fullCalendar('getView').slotCnt, 'days').endOf('day').format().substr(0,16), $('#calendarWynajem').fullCalendar('getView').name)
        );

        $('body').on('click', 'button.fc-timelineMonthCustom-button', () =>
            this.getEventsNow(moment($('#calendarWynajem').fullCalendar('getDate')).startOf('month').format().substr(0,16), moment($('#calendarWynajem').fullCalendar('getDate')).endOf('month').endOf('day').format().substr(0,16), $('#calendarWynajem').fullCalendar('getView').name)
        );

    }

    getCalendar(event, startDate, view) {
        $('#calendarWynajem').fullCalendar('destroy');
        $('#calendarWynajem').fullCalendar({
            schedulerLicenseKey: '0679243936-fcs-1547637957',
            locale: 'pl',
            eventOrder: 'liczbaPasazerow',
            header: {
                left: 'prev,next',
                center: 'title',
                right: 'timelineEightDays,timelineTenDays,timelineMonthCustom'
            },
            titleFormat: 'DD MMMM YYYY',
            defaultDate: startDate,
            defaultView: view,
            views: {
                timelineEightDays: {
                    slotLabelFormat: 'ddd D.MM',
                    type: 'timelineMonth',
                    duration: {days: 7},
                    slotDuration: '24:00'
                },
                timelineTenDays: {
                    slotLabelFormat: 'ddd D.MM',
                    type: 'timelineMonth',
                    duration: {days: 14},
                    slotDuration: '24:00'
                },
                timelineMonthCustom: {
                    type: 'timelineMonth',
                    duration: {month: 1},
                    slotDuration: '24:00',
                    buttonText: 'miesiąc'
                }
            },
            events: event,
            eventRender: this.eventRender,
            eventClick: this.eventClick.bind(this),
        })
        this.setState({pokazFormularz: false})

    }

    eventClick(event) {
        localStorage.setItem('kalendarz', JSON.stringify({startDate: this.state.startDate, view: this.state.view}))
        localStorage.setItem('EBUS_EdycjaWynajem', JSON.stringify(event.id))
        this.setState({pokazFormularz: (Boolean(LogowanieService.czyPosiadaRole(['ROLE_WYNAJEM_ODCZYT_LISTA'])))? false : true})
    }

    eventRender(event, element) {
        element.html(
            event.status +
            "<div class='calendarEvent'>" +
            ((Boolean(LogowanieService.czyPosiadaRole(['ROLE_WYNAJEM_ODCZYT_LISTA'])))? "" : "<p class='eventTytul'>" + event.tytul + "<font class='eventTrasa'> (" + event.miejsceOd + " - " + event.miejsceDo + ")</font></p><p><i class='iClass fa fa-user'> </i><b> " + event.wynajem.klientNazwa + "</b></p>") +
            // "<p class='eventTytul'>" + event.tytul + "<font class='eventTrasa'> (" + event.miejsceOd + " - " + event.miejsceDo + ")</font></p>" +
            // "<p><i class='iClass fa fa-user'> </i><b> " + event.wynajem.klientNazwa + "</b></p>" +
            "<p><i class='iClass fa fa-id-card'> </i><b> " + event.wynajemKierowcy + "</b></p>" +
            "<p class='eventPojazd'><i class='iClass fa fa-bus'> </i> <font class='eventNrRej'>" + event.nrRej + "</font><b>" + event.pojazd + "</b></p>" +
            "<p><i class='iClass fa fa-male' style='margin-right: 3px'> </i> <b>" + event.liczbaPasazerow + "</b></p>" +
            "</div>");
    }

    getEventsNow(start, end, view) {
        this.setState({startDate: start, view: view, loading: true})
        let eventTab = []
        KalendarzService.getWynajemData(start, end)
            .then(function (response) {
                if (response !== undefined) {
                    for (let i = 0; i < response.data.length; i++) {

                        let tytul, pojazd;

                        if (response.data[i].tytul === null) {
                            tytul = '-'
                        } else {
                            tytul = response.data[i].tytul
                        }

                        if (response.data[i].pojazd === null) {
                            pojazd = {marka: '-', model: '-', nrRej: '-'}
                        } else {
                            pojazd = response.data[i].pojazd
                        }

                        let kierowcy = [];
                        let status;
                        if (response.data[i].wynajemKierowcy !== null) {
                            for (let j = 0; j < response.data[i].wynajemKierowcy.length; j++) {
                                kierowcy += "<font style='background: #d0e1f5; border-radius: 3px; padding: 3px 5px 3px 5px; margin-left: 3px; margin-right: 3px'>" + response.data[i].wynajemKierowcy[j].kierowca.imie + " " + response.data[i].wynajemKierowcy[j].kierowca.nazwisko + "</font>"
                            }
                        }

                        if (response.data[i].status === 1) {
                            status = "<div style='background: #eec24d; font-size: 5px;'>&nbsp;</div>"
                        } else {
                            if (response.data[i].status === 2) {
                                status = "<div style='background: #f58989; font-size: 5px;'>&nbsp;</div>"
                            } else {
                                if (response.data[i].status === 3) {
                                    status = "<div style='background: #7db6f3; font-size: 5px'>&nbsp;</div>"
                                } else {
                                    status = "<div style='background: #7fd28c; font-size: 5px'>&nbsp;</div>"
                                }
                            }
                        }
                        this.setState(prevState => ({
                            events: [...prevState.events,
                                {
                                    id: response.data[i].idWy,
                                    wynajem: response.data[i],
                                    tytul: tytul.toUpperCase(),
                                    dataOd: response.data[i].dataOd,
                                    dataDo: response.data[i].dataDo,
                                    pojazd: pojazd.marka.toUpperCase() + ' ' + pojazd.model.toUpperCase(),
                                    miejsceOd: response.data[i].miejsceOd,
                                    miejsceDo: response.data[i].miejsceDo,
                                    nrRej: pojazd.nrRej,
                                    wynajemKierowcy: kierowcy,
                                    status: status,
                                    liczbaPasazerow: response.data[i].ileOsob,
                                    start: response.data[i].dataOd,
                                    end: response.data[i].dataDo,
                                }]
                        }))
                        eventTab.push({
                            id: response.data[i].idWy,
                            wynajem: response.data[i],
                            tytul: tytul.toUpperCase(),
                            dataOd: response.data[i].dataOd,
                            dataDo: response.data[i].dataDo,
                            pojazd: pojazd.marka.toUpperCase() + ' ' + pojazd.model.toUpperCase(),
                            miejsceOd: response.data[i].miejsceOd,
                            miejsceDo: response.data[i].miejsceDo,
                            nrRej: pojazd.nrRej,
                            wynajemKierowcy: kierowcy,
                            status: status,
                            liczbaPasazerow: response.data[i].ileOsob,
                            start: response.data[i].dataOd,
                            end: response.data[i].dataDo,
                        })
                    }
                    this.setState({loading: false})
                    this.getCalendar(eventTab, start, view)

                }
            }.bind(this))
    }

    componentWillMount() {
        this.getEventsNow(this.state.startDate, moment().add(14, 'days').endOf('day').format().substr(0,16), this.state.view)
    }

    render() {

        if (this.state.pokazFormularz) {
            if (localStorage.getItem('EBUS_EdycjaWynajem') === null) {
                return <Redirect to={"/konfiguracja/wynajem/formularz"}/>
            } else {
                return <Redirect to={"/konfiguracja/wynajem/" + localStorage.getItem('EBUS_EdycjaWynajem')}/>
            }
        } else
            return (
                <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path}
                                  history={this.props.history}
                                  collapsedLinks={this.props.collapsedLinks}
                                  handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                    <Grid fluid={true} id={'ZarzadzanieContainer'}>
                        <Row>
                            <Col sm={12}>
                                <div id="subheader">
                                    <TopBreadcumb links={[{
                                        addressUrl: '/konfiguracja',
                                        text: 'Konfiguracja'
                                    }, {
                                        addressUrl: '/konfiguracja/wynajem',
                                        text: 'Wynajem'
                                    }, {addressUrl: '/konfiguracja/wynajem/kalendarz', text: 'Kalendarz'}]}/>
                                    <SubHeader currentLink={this.props.match.path}
                                               obecnyKalendarz={this.props.obecnyKalendarz}
                                               history={this.props.history}/>
                                </div>
                            </Col>

                            <Col sm={12}>
                                <TopAlertInformacja
                                    text={'Aby wyświetlić szczegóły lub edytować wynajem należy kliknąć na wybrany element.'}/>

                            </Col>
                            <Col sm={6}>
                                <Row>
                                    <Col sm={1}
                                         style={{paddingTop: 4, paddingRight: 6, fontSize: 12}}>
                                        Legenda:
                                    </Col>
                                    <Col sm={2} style={{paddingLeft: 3, paddingRight: 3}}>
                                        <div style={{
                                            background: '#eec24d',
                                            color: 'white',
                                            fontWeight: 'bold',
                                            borderRadius: 5,
                                            fontSize: 12,
                                            textAlign: 'center',
                                            paddingTop: 2,
                                            paddingBottom: 2
                                        }}>ZAPYTANIE
                                        </div>
                                    </Col>
                                    <Col sm={2} style={{paddingLeft: 3, paddingRight: 3}}>
                                        <div style={{
                                            background: '#f58989',
                                            color: 'white',
                                            fontWeight: 'bold',
                                            borderRadius: 5,
                                            fontSize: 12,
                                            textAlign: 'center',
                                            paddingTop: 2,
                                            paddingBottom: 2
                                        }}>REZERWACJA
                                        </div>
                                    </Col>
                                    <Col sm={2} style={{paddingLeft: 3, paddingRight: 3}}>
                                        <div style={{
                                            background: '#7db6f3',
                                            color: 'white',
                                            fontWeight: 'bold',
                                            borderRadius: 5,
                                            fontSize: 12,
                                            textAlign: 'center',
                                            paddingTop: 2,
                                            paddingBottom: 2
                                        }}>ZAMÓWIENIE
                                        </div>
                                    </Col>
                                    <Col sm={2} style={{paddingLeft: 3}}>
                                        <div style={{
                                            background: '#7fd28c',
                                            color: 'white',
                                            fontWeight: 'bold',
                                            borderRadius: 5,
                                            fontSize: 12,
                                            textAlign: 'center',
                                            paddingTop: 2,
                                            paddingBottom: 2
                                        }}>WYKONANO
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                            <Col sm={6} style={{marginBottom: 10}}>
                                <TopIf isTrue={(!Boolean(this.state.pokazFormularz) && (!Boolean(LogowanieService.czyPosiadaRole(['ROLE_WYNAJEM_ODCZYT_LISTA']))))}>
                                    <KonfiguracjaHeader
                                        pokazFormularz={() => {localStorage.setItem('kalendarz', JSON.stringify({startDate: this.state.startDate, view: this.state.view}));this.setState({pokazFormularz: true})}}
                                        tekstDodaj={'Dodaj wynajem'}
                                        pokazButtonSzukaj={false}/>

                                </TopIf></Col>
                            <Col sm={12}>
                                {this.state.loading ? <center><i style={{color: '#53A53C', marginTop: 150}}
                                                                 className={'fa fa-4x fa-spinner fa-spin'}></i>
                                    </center> :
                                    <div id="calendarWynajem"></div>}
                            </Col>
                        </Row>
                    </Grid>
                </SidebarComponent>
            );
    }
}



// WEBPACK FOOTER //
// ./src/modules/konfiguracja/wynajemConfig/kalendarz/KalendarzContainer.js